<script setup lang="ts">
  import LinkIcon from '@/shared/assets/icons/LinkIcon.svg';
  import UploadIcon from '@/shared/assets/icons/UploadIcon.svg';
  import ExternalUploadTipsHeader from './tips/ExternalUploadTipsHeader.vue';
  import UploadMethodCard from '../tips/UploadMethodCard.vue';

  interface Requirement {
    text: string;
    emphasized?: string;
    hasLineBreak?: boolean;
  }

  const uploadRequirements: Requirement[] = [
    {
      text: 'O nome do documento é livre, porém será salvo com o prefixo (DE), para indicar que é um Documento Externo. \n O sufixo é adicionado automaticamente, não sendo necessário adicionar no título do documento.',
    },
  ];

  const urlRequirements: Requirement[] = [
    {
      text: 'A URL deve seguir a mesma fórmula de título do documento enviado por Upload, com o prefixo sendo adicionado automaticamente.',
    },
  ];
</script>

<template>
  <div
    id="tip-wrapper"
    class="flex flex-col gap-3 border border-gray-03 rounded-xl p-5 text-sm bg-gray-14"
  >
    <!-- Top part -->
    <ExternalUploadTipsHeader />

    <!-- Bottom part -->
    <div class="flex gap-6 mt-0 w-full">
      <UploadMethodCard
        :icon="UploadIcon"
        title="Upload"
        example="Exemplo: Guia de Validação de Sistemas Computadorizados.pdf"
        :requirements="uploadRequirements"
        :bullet-point="false"
      />
      <UploadMethodCard
        :icon="LinkIcon"
        title="URL"
        :requirements="urlRequirements"
        :bullet-point="false"
      />
    </div>
  </div>
</template>
